import PropTypes from "prop-types";

// @mui material components
import { Card, CardContent, Link } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

import {colorIdentifier} from "../../../../../services/common";

export const FileList = ({ files }) => (
  <div>
    {files.map((i) => (
      <MDBox key={i.id} mb={2}>
        <Card>
          <CardContent
  sx={{
    borderRadius: "12px", // Bordes redondeados
    transition: "background-color 0.3s ease-in-out", // Animación suave
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)", // Color gris claro
    },
  }}>
            <Link href={`/file/detail/${i.id}`} color="inherit" underline="none">
              <MDBox component="li" display="flex" alignItems="center" mb={-2}>
                <MDBox
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"

                >
                  <MDTypography variant="button" fontWeight="medium">
                    {i.jurisdiccion} {i.numero}/{i.anio}
                  </MDTypography>
                  <MDTypography variant="button" fontWeight="medium" color="text">
                    {i.caratula}
                  </MDTypography>
                </MDBox>
                <MDBox ml="auto">
                  <MDBadge
                    badgeContent={i.estado}
                    color={colorIdentifier(i.estado)}
                    container
                  ></MDBadge>
                </MDBox>
              </MDBox>
            </Link>
          </CardContent>
        </Card>
      </MDBox>
    ))}
  </div>
);

FileList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      jurisdiccion: PropTypes.string.isRequired,
      numero: PropTypes.number.isRequired,
      anio: PropTypes.number.isRequired,
      caratula: PropTypes.string.isRequired,
      estado: PropTypes.string.isRequired,
    })
  ).isRequired,
};